<div class="container">
	<div class="col-4">
		<div class="form-group">
			<sanabel-selectize appcode="1020" [SearchKeys]="{haveUsers : 1}" [outlineSize]="0" [radiusSize]="25" [cancelColor]="'#dc3545'" [borderColor]="'#24b4e9'" [textColor]="'#24b4e9'" (clicked)="getUserId($event)">
			</sanabel-selectize>

		</div>
	</div>

	<h3 class=" text-center chat_header chatwith"> <i class="fa fa-user-md" aria-hidden="true"></i>Chat With
		{{selectedEmp?.name}} {{namen}} </h3>
	<div class="messaging">
		<div class="inbox_msg">
			<div class="inbox_people">
				<div class="headind_srch">
					<div class="recent_heading">
						<h4>Recent</h4>
					</div>
					<div class="srch_bar">
						<div class="stylish-input-group">
							<input type="text" class="search-bar" #searchInput placeholder="Search"
								(keyup)="onsearch(searchInput.value)">
							<i class="fa fa-search" aria-hidden="true"></i>
						</div>
					</div>
				</div>
				<div class="inbox_chat scroll text-center">
					<div class="btn-group">
						<button type="button" width="50px" (click)="activeTab = 1"
							[ngClass]="{'active': activeTab == 1}" class="btn btn-primary rounded-0">online</button>
						<button type="button" width="50px" (click)="activeTab = 2"
							[ngClass]="{'active': activeTab == 2}" class="btn btn-primary rounded-0">History</button>
					</div>
					<div *ngIf="activeTab == 1">
						<div class="chat_list" [ngClass]="{'active_chat': employee.empId == activeEmp}"
							*ngFor="let employee of activeUsers"
							(click)="selectEmployee(employee); activeEmp = employee.empId;">
							<div class="chat_people d-flex align-items-center">
								<div class="m-auto">
									<p class="lead hover pointer"
										[ngClass]="{'font-weight-bold text-danger': employee.unreadMsg == 1}">
										<span *ngIf="employee.unreadMsg == 1" class="fas fa-bell text-danger"></span>
										{{employee.name.length > 1 ? employee.name : employee.userName}}
									</p>
								</div>
								<span class="fas fa-circle fa-custom-circle"></span>
								<div class="avatar small-avatar">
									<span *ngIf="employee.shortName">{{employee.shortName}}</span>
									<span *ngIf="!employee.shortName" class="fas fa-user-md"></span>
								</div>
							</div>
						</div>
					</div>
					<div *ngIf="activeTab == 2">
						<div class="chat_list" [ngClass]="{'active_chat': employee.empId == activeEmp}"
							*ngFor="let employee of recentChat"
							(click)="selectEmployee(employee); activeEmp = employee.empId;">
							<div class="chat_people d-flex align-items-center">
								<div class="m-auto">
									<p class="lead hover pointer">
										{{employee.name.length > 1 ? employee.name : employee.userName}}
									</p>
								</div>
								<span class="fas fa-circle"
									[ngClass]="{'fa-custom-circle':employee.active==1 ,'sa-custom-circle':employee.active!=1}"></span>
								<div class="avatar small-avatar">
									<span *ngIf="employee.shortName">{{employee.shortName}}</span>
									<span *ngIf="!employee.shortName" class="fas fa-user-md"></span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="mesgs">
				<div class="msg_history">
					<div *ngFor="let msg of messages">
						<div class="incoming_msg d-flex align-items-center" *ngIf="msg.type == 'received'">
							<div class="avatar bg-custom-gray" style="width: 65.33px;">
								<span *ngIf="msg.recieverShortName || msg.senderShortName">
									{{msg.recieverShortName ? msg.recieverShortName : msg.senderShortName}}
								</span>
								<span *ngIf="!msg.recieverShortName && !msg.senderShortName"
									class="fas fa-user-md"></span>
							</div>
							<span class="fas fa-circle fa-custom-circle" style="right: -10px;"></span>
							<div class="received_msg">
								<div class="received_withd_msg">
									<p>
										{{msg.message}}
									</p>
									<span class="time_date"> {{msg.date | date:'medium'}} </span>
								</div>
							</div>
						</div>
						<div class="outgoing_msg d-flex align-items-center" *ngIf="msg.type == 'sent'">
							<div class="mr-auto sent_msg">
								<p>
									{{msg.message}}
								</p>
								<span class="time_date text-left">{{msg.date | date:'medium'}}</span>
							</div>
							<span class="fas fa-circle fa-custom-circle"></span>
							<div class="avatar">
								<span *ngIf="senderShortName">
									{{senderShortName}}
								</span>

								<span *ngIf="!senderShortName" class="fas fa-user-md"></span>
							</div>
						</div>
					</div>
				</div>
				<div class="type_msg">
					<div class="input_msg_write">
						<input type="text" [value]="txtMessage" (input)="txtMessage=$event.target.value"
							(keydown.enter)="sendMessage()" class="write_msg" placeholder="Type a message" />
						<button class="msg_send_btn" type="button" (click)="sendMessage()"><i
								class="fa fa-paper-plane-o" aria-hidden="true"></i></button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>


<!--  -->
<!--  -->

<!--  -->
<!--  -->